import { ReactElement } from 'react'
import styles from './WebNavigation.module.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import { MAIN_ROUTES, NavigationItems } from '../../config/navigationItems'
import {
  FacebookIconImage,
  FightbackLogoImage,
  InstagramIconImage,
  WhatsAppIconImage,
  YoutubeIconImage,
} from '../icon/Icon'
import { DesktopTitleMedium } from '../../Typography'
import { URLS } from '../../content/urls'
import { ROUTES } from '../../config/routes'

export const WebNavigation = (): ReactElement => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <header
      className={location.pathname === ROUTES.start ? styles.header : styles.headerWithBackground}
    >
      <div className={styles.logoBox} onClick={(): void => navigate(ROUTES.start)}>
        {FightbackLogoImage}
      </div>
      <div className={styles.navItemBox}>
        {NavigationItems.map((item): ReactElement => {
          const isCurrentScreen =
            item.route === ROUTES.start
              ? !MAIN_ROUTES.some((route) => location.pathname.startsWith(route))
              : location.pathname === item.route || location.pathname.startsWith(item.route + '/')

          return (
            <DesktopTitleMedium
              className={styles.navItem}
              opacity={isCurrentScreen ? 1 : 0.25}
              key={item.name}
              onClick={(): void => {
                navigate(item.route)
              }}
            >
              {item.name}
            </DesktopTitleMedium>
          )
        })}
        <div className={styles.navIconBox}>
          <a href={URLS.youtube} target='_blank' rel='noreferrer'>
            {YoutubeIconImage}
          </a>
          <a href={URLS.facebook} target='_blank' rel='noreferrer'>
            {FacebookIconImage}
          </a>
          <a href={URLS.instagram} target='_blank' rel='noreferrer'>
            {InstagramIconImage}
          </a>
          <a href={URLS.whatsapp} target='_blank' rel='noreferrer'>
            {WhatsAppIconImage}
          </a>
        </div>
      </div>
    </header>
  )
}
